<!-- Toast notifications -->
<p-toast key="register"></p-toast>
<p-toast key="main"></p-toast>
<p-contextMenu #cmu [model]="contextMenuUsers"></p-contextMenu>
<p-contextMenu #cmr [model]="contextMenuRole"></p-contextMenu>

<!-- Modern Header Section -->
<div class="m-4">
  <div class="settings-header">
    <div class="header-content">
      <div class="header-left">
        <h1 class="settings-title">
          <i class="pi pi-cog mr-3"></i>
          Settings
        </h1>
        <p class="settings-subtitle">
          Manage your account and system preferences
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Main Content Area -->
<div class="m-4 settings-content">
  <p-tabView class="modern-tabview">
    <!-- Members & Roles Tab -->
    <p-tabPanel
      header="Members & Roles"
      leftIcon="pi pi-users"
      *ngIf="currentUser.role?.name == 'admin'"
    >
      <div class="tab-content">
        <!-- Users Section -->
        <div class="content-section">
          <div class="section-header">
            <div class="header-info">
              <h2 class="section-title">User Management</h2>
              <p class="section-description">
                Manage your team members and their roles
              </p>
            </div>
            <button
              pButton
              pRipple
              label="Register User"
              icon="pi pi-plus"
              class="modern-button primary"
              (click)="showUserRegisterDialog()"
            ></button>
          </div>

          <div class="table-container">
            <p-table
              #dt1
              [value]="(members$ | async) || []"
              [tableStyle]="{ 'min-width': '60rem' }"
              [rowHover]="true"
              [scrollable]="true"
              scrollHeight="50vh"
              [(contextMenuSelection)]="selectedMember"
              [contextMenu]="cmu"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500]"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [globalFilterFields]="[
                'first_name',
                'last_name',
                'email',
                'company_name'
              ]"
              class="modern-table"
            >
              <ng-template pTemplate="caption">
                <div class="table-search">
                  <div class="search-container">
                    <i class="pi pi-search search-icon"></i>
                    <input
                      pInputText
                      type="text"
                      (input)="filterGlobal1($event)"
                      placeholder="Search users..."
                      class="modern-search"
                    />
                  </div>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr class="table-header">
                  <th
                    *ngFor="let col of userColumns"
                    [pSortableColumn]="col.field"
                  >
                    <div class="header-cell">
                      <i class="pi pi-sort-alt mr-2"></i>
                      {{ col.header }}
                    </div>
                  </th>
                  <th></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-member>
                <tr
                  class="table-row"
                  (click)="showUserDetailsDialog(member, $event)"
                  [pContextMenuRow]="member"
                >
                  <td *ngFor="let col of userColumns" class="table-cell">
                    <div class="cell-content">
                      <span class="cell-text">{{ member[col.field] }}</span>
                    </div>
                  </td>
                  <td class="table-cell">
                    <button
                      type="button"
                      pButton
                      icon="pi pi-ellipsis-v"
                      class="modern-button secondary small"
                      (click)="
                        menu.toggle($event);
                        storeRowDetail(member);
                        $event.stopPropagation()
                      "
                    ></button>
                    <p-menu
                      #menu
                      appendTo="body"
                      [popup]="true"
                      [model]="items"
                    ></p-menu>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td
                    [attr.colspan]="this.getNumberofColumns()"
                    class="empty-state"
                  >
                    <p-progressBar
                      *ngIf="isLoadingUsers"
                      mode="indeterminate"
                      class="loading-bar"
                    ></p-progressBar>
                    <div *ngIf="!isLoadingUsers" class="empty-content">
                      <i class="pi pi-users empty-icon"></i>
                      <h3>No users found</h3>
                      <p>Get started by registering your first team member</p>
                      <button
                        pButton
                        pRipple
                        label="Register User"
                        icon="pi pi-plus"
                        class="modern-button secondary"
                        (click)="showUserRegisterDialog()"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>

        <!-- Roles Section -->
        <div class="content-section">
          <div class="section-header">
            <div class="header-info">
              <h2 class="section-title">Role Management</h2>
              <p class="section-description">
                Manage user roles and permissions
              </p>
            </div>
            <button
              pButton
              pRipple
              label="Add Role"
              icon="pi pi-plus"
              class="modern-button primary"
              (click)="showCreateRoleDialog()"
            ></button>
          </div>

          <div class="table-container">
            <p-table
              #dt
              [value]="(roles$ | async) || []"
              [tableStyle]="{ 'min-width': '60rem' }"
              [rowHover]="true"
              [(contextMenuSelection)]="selectedRole"
              [contextMenu]="cmr"
              [paginator]="true"
              [rows]="100"
              [rowsPerPageOptions]="[100, 200, 500]"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
              [globalFilterFields]="['name', 'description']"
              class="modern-table"
            >
              <ng-template pTemplate="caption">
                <div class="table-search">
                  <div class="search-container">
                    <i class="pi pi-search search-icon"></i>
                    <input
                      pInputText
                      type="text"
                      (input)="filterGlobal($event)"
                      placeholder="Search roles..."
                      class="modern-search"
                    />
                  </div>
                </div>
              </ng-template>

              <ng-template pTemplate="header">
                <tr class="table-header">
                  <th
                    *ngFor="let col of roleColumns"
                    [pSortableColumn]="col.field"
                  >
                    <div class="header-cell">
                      <i class="pi pi-sort-alt mr-2"></i>
                      {{ col.header }}
                    </div>
                  </th>
                  <th>
                    <div class="header-cell">
                      <i class="pi pi-users mr-2"></i>
                      Users
                    </div>
                  </th>
                  <th></th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-role>
                <tr
                  class="table-row"
                  (click)="showRoleDetailDialog(role, $event)"
                  [pContextMenuRow]="role"
                >
                  <td *ngFor="let col of roleColumns" class="table-cell">
                    <div class="cell-content">
                      <span class="cell-text">{{ role[col.field] }}</span>
                    </div>
                  </td>
                  <td class="table-cell">
                    <div class="cell-content">
                      <span class="cell-text">{{ role.users }}</span>
                    </div>
                  </td>
                  <td class="table-cell">
                    <button
                      type="button"
                      pButton
                      icon="pi pi-ellipsis-v"
                      class="modern-button secondary small"
                      (click)="
                        menu2.toggle($event);
                        storeRowDetail(role);
                        $event.stopPropagation()
                      "
                    ></button>
                    <p-menu
                      #menu2
                      appendTo="body"
                      [popup]="true"
                      [model]="roleItems"
                    ></p-menu>
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td
                    [attr.colspan]="this.getNumberofColumns()"
                    class="empty-state"
                  >
                    <p-progressBar
                      *ngIf="isLoadingRoles"
                      mode="indeterminate"
                      class="loading-bar"
                    ></p-progressBar>
                    <div *ngIf="!isLoadingRoles" class="empty-content">
                      <i class="pi pi-shield empty-icon"></i>
                      <h3>No roles found</h3>
                      <p>Get started by creating your first role</p>
                      <button
                        pButton
                        pRipple
                        label="Add Role"
                        icon="pi pi-plus"
                        class="modern-button secondary"
                        (click)="showCreateRoleDialog()"
                      ></button>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </p-tabPanel>

    <!-- Profile Tab -->
    <p-tabPanel header="Profile" leftIcon="pi pi-user">
      <div class="tab-content">
        <div class="content-section">
          <div class="section-header">
            <div class="header-info">
              <h2 class="section-title">Profile Settings</h2>
              <p class="section-description">
                Update your personal information and preferences
              </p>
            </div>
          </div>

          <div class="profile-form-container">
            <form
              [formGroup]="this.userService.updateUserForm"
              (ngSubmit)="updateProfile(currentUser.id)"
              class="modern-form"
            >
              <div class="form-grid">
                <div class="form-field">
                  <label for="first_name" class="form-label">First Name</label>
                  <input
                    id="first_name"
                    type="text"
                    pInputText
                    formControlName="first_name"
                    [(ngModel)]="currentUser.first_name"
                    class="modern-input"
                  />
                  <div
                    class="error-message"
                    *ngIf="
                      this.userService.updateUserForm.get('first_name')
                        ?.invalid &&
                      (this.userService.updateUserForm.get('first_name')
                        ?.touched ||
                        this.userService.updateUserForm.get('first_name')
                          ?.dirty)
                    "
                  >
                    <small class="error-text">First Name is required</small>
                  </div>
                </div>

                <div class="form-field">
                  <label for="last_name" class="form-label">Last Name</label>
                  <input
                    id="last_name"
                    type="text"
                    pInputText
                    formControlName="last_name"
                    [(ngModel)]="currentUser.last_name"
                    class="modern-input"
                  />
                  <div
                    class="error-message"
                    *ngIf="
                      this.userService.updateUserForm.get('last_name')
                        ?.invalid &&
                      (this.userService.updateUserForm.get('last_name')
                        ?.touched ||
                        this.userService.updateUserForm.get('last_name')?.dirty)
                    "
                  >
                    <small class="error-text">Last Name is required</small>
                  </div>
                </div>

                <div class="form-field">
                  <label for="username" class="form-label">Username</label>
                  <input
                    id="username"
                    type="text"
                    pInputText
                    formControlName="username"
                    [(ngModel)]="currentUser.username"
                    class="modern-input"
                  />
                  <div
                    class="error-message"
                    *ngIf="
                      !this.userService.updateUserForm.get('username')?.valid &&
                      this.userService.updateUserForm.get('username')?.touched
                    "
                  >
                    <small class="error-text">Username is required</small>
                  </div>
                </div>

                <div class="form-field">
                  <label for="email" class="form-label">Email</label>
                  <input
                    id="email"
                    type="email"
                    pInputText
                    formControlName="email"
                    [(ngModel)]="currentUser.email"
                    class="modern-input"
                  />
                  <div
                    class="error-message"
                    *ngIf="
                      this.userService.updateUserForm.get('email')?.invalid &&
                      (this.userService.updateUserForm.get('email')?.touched ||
                        this.userService.updateUserForm.get('email')?.dirty)
                    "
                  >
                    <small class="error-text">Email is required</small>
                  </div>
                </div>

                <div class="form-field">
                  <label class="form-label">Role</label>
                  <div class="info-display">
                    <p-tag class="modern-tag">{{
                      currentUser.role.name
                    }}</p-tag>
                  </div>
                </div>

                <div
                  *ngIf="
                    currentUser.role.name !== 'clinic-admin' &&
                    currentUser.role.name !== 'hq-clinic-admin' &&
                    currentUser.role.name !== 'hq-clinic-user' &&
                    currentUser.role.name !== 'zpl-clinic-user'
                  "
                  class="form-field"
                  formGroupName="customer"
                >
                  <label class="form-label">Customer</label>
                  <div class="info-display">
                    <div
                      *ngIf="currentUser.customer.company_name; else noCustomer"
                    >
                      <p-tag class="modern-tag">{{
                        currentUser.customer.company_name
                      }}</p-tag>
                    </div>
                    <ng-template #noCustomer>
                      <p-tag severity="info" class="modern-tag"
                        >No Customer Linked</p-tag
                      >
                    </ng-template>
                  </div>
                </div>
              </div>

              <div class="form-actions">
                <button
                  [loading]="loading"
                  pButton
                  pRipple
                  type="submit"
                  label="Save Changes"
                  icon="pi pi-check"
                  class="modern-button primary"
                ></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!-- Confirmation dialog -->
<p-confirmDialog header="Delete"></p-confirmDialog>
